export const domainServer = process.env.REACT_APP_SERVER_API;
export const wsDomain = process.env.REACT_APP_WS_API;
export const domainAutoLogin = process.env.REACT_APP_AUTOLOGIN_API;
export const secretKey = process.env.REACT_APP_ACC_GAME_SECRET_KEY;
